import { render, staticRenderFns } from "./auditAuthOwnerUndoList.vue?vue&type=template&id=3873b9de&scoped=true"
import script from "./auditAuthOwnerUndoList.vue?vue&type=script&lang=js"
export * from "./auditAuthOwnerUndoList.vue?vue&type=script&lang=js"
import style0 from "./auditAuthOwnerUndoList.vue?vue&type=style&index=0&id=3873b9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873b9de",
  null
  
)

export default component.exports